/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Edit } from "@material-ui/icons";
import PhoneInput from "../Shared/PhoneInput";
import EmailInput from "../Shared/EmailInput";
import HelmetTag from "../Shared/HelmetTag";
import NavbarRedesignForMarketplace from "../Shared/NavbarRedesignForMarketplace";
import MainBackgroundWrapper from "../Shared/MainBackgroundWrapperForMarketplace";
import SignupModal from "../Shared/SignupModal";
import {
  updateClientById,
  resetPasswordSubmission,
  presignAvatar,
  uploadAvatar,
  saveAvatar,
  getClient,
} from "../Shared/Helpers";
import { loadClient } from "../../Actions";
import LoadingOverlay from "../Shared/LoadingOverlay";
import ErrorModal from "../Shared/ErrorModal";
import LatestModalDesign from "../Shared/LatestModalDesign";
import checkMark from "../../Assets/Images/Check_mark.png";
import { generalCheckPassRules } from "../../constants";
import avatar from "../../Assets/Images/placeholder.png";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      openAccountInfo: false,
      openPMethods: false,
      openABook: false,
      bgImagePath: "",
      // Form state
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      currentPassword: "********",
      isValidPhone: false,
      isValidEmail: false,
      emailIsValid: false,
      countryCode: "",
      // Edit states
      editingPhone: false,
      openChangePassword: false,
      // Temporary edit values
      tempFirstName: "",
      tempLastName: "",
      tempPhone: "",
      tempEmail: "",
      // Password change state
      currentPasswordInput: "",
      newPassword: "",
      confirmNewPassword: "",
      // Loading and error states
      loading: false,
      error: "",
      showErrorModal: false,
      success: false,

    };
    this.mainView = this.mainView.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.startEditingPhone = this.startEditingPhone.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.savePhoneChange = this.savePhoneChange.bind(this);
    this.saveNameChange = this.saveNameChange.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.saveEmailChange = this.saveEmailChange.bind(this);
    this.closePasswordModal = this.closePasswordModal.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.saveFieldChange = this.saveFieldChange.bind(this);
    this.handleAvatarChange = this.handleAvatarChange.bind(this);
    this.initializeFormFields = this.initializeFormFields.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });
    this.setState({ bgImagePath: "#FFFFFF" });

    // Initialize form with user data
    this.initializeFormFields();
  }

  componentDidUpdate(prevProps) {
    // Update form fields when client data changes
    if (prevProps.client !== this.props.client) {
      this.initializeFormFields();
    }
  }

  initializeFormFields() {
    const client = this.props.client || {};
    const email = get(client, "email", "");
    const firstName = get(client, "first_name", "");
    const lastName = get(client, "last_name", "");
    const phone = get(client, "mobile_number", "") || get(client, "phone", "");

    // Only update if we have client data
    if (client.user_id) {
      // Always update the fields to ensure they're in sync with props
      this.setState({
        firstName: firstName || "",
        lastName: lastName || "",
        email: email || "",
        phone: phone || "",
        emailIsValid: email ? true : false,
        isValidEmail: email ? true : false,
      });
    }
  }

  handlePhoneChange({ isValidNumber, number, countryCode }) {
    this.setState({
      phone: number,
      isValidPhone: isValidNumber,
      countryCode: countryCode,
    });
  }

  handleEmailChange({ email, isValid }) {
    this.setState({
      email,
      isValidEmail: isValid,
    });
  }

  startEditingPhone() {
    this.setState({
      editingPhone: true,
      tempPhone: this.state.phone,
    });
  }

  cancelEdit() {
    this.setState({
      editingPhone: false,
      tempPhone: "",
      isValidPhone: false,
    });
  }

  savePhoneChange() {
    if (!this.state.isValidPhone) {
      this.setState({
        error: "Please enter a valid phone number",
        showErrorModal: true,
      });
      return;
    }

    const userId = get(this.props, "client.user_id");
    this.setState({ loading: true });

    updateClientById(
      userId,
      { mobile_number: this.state.tempPhone },
      (response) => {
        const client = get(response, "data.client", {});
        this.props.loadClient({ ...client, loggedIn: true });
        this.setState({
          phone: this.state.tempPhone,
          editingPhone: false,
          tempPhone: "",
          loading: false,
          success: true,
        });
        setTimeout(() => this.setState({ success: false }), 3000);
      },
      (error) => {
        console.error("Error updating phone:", error);
        this.setState({
          error: "Failed to update phone number. Please try again.",
          showErrorModal: true,
          loading: false,
        });
      }
    );
  }

  saveFieldChange(field, value) {
    if (!value || !value.trim()) {
      this.setState({
        error: `${field} is required`,
        showErrorModal: true,
      });
      return;
    }

    const userId = get(this.props, "client.user_id");
    this.setState({ loading: true });

    const updateData = {};
    if (field === "First Name") updateData.first_name = value.trim();
    if (field === "Last Name") updateData.last_name = value.trim();
    if (field === "Email") updateData.email = value.trim();

    updateClientById(
      userId,
      updateData,
      (response) => {
        const client = get(response, "data.client", {});
        this.props.loadClient({ ...client, loggedIn: true });

        const stateUpdate = { loading: false, success: true };
        if (field === "First Name") stateUpdate.firstName = value;
        if (field === "Last Name") stateUpdate.lastName = value;
        if (field === "Email") stateUpdate.email = value;

        this.setState(stateUpdate);
        setTimeout(() => this.setState({ success: false }), 3000);
      },
      (error) => {
        console.error(`Error updating ${field.toLowerCase()}:`, error);
        this.setState({
          error: `Failed to update ${field.toLowerCase()}. Please try again.`,
          showErrorModal: true,
          loading: false,
        });
      }
    );
  }

  saveNameChange() {
    // This function is kept for backward compatibility but redirects to saveFieldChange
    if (!this.state.firstName.trim() || !this.state.lastName.trim()) {
      this.setState({
        error: "Both first name and last name are required",
        showErrorModal: true,
      });
      return;
    }

    const userId = get(this.props, "client.user_id");
    this.setState({ loading: true });

    updateClientById(
      userId,
      {
        first_name: this.state.firstName.trim(),
        last_name: this.state.lastName.trim(),
      },
      (response) => {
        const client = get(response, "data.client", {});
        this.props.loadClient({ ...client, loggedIn: true });
        this.setState({
          loading: false,
          success: true,
        });
        setTimeout(() => this.setState({ success: false }), 3000);
      },
      (error) => {
        console.error("Error updating name:", error);
        this.setState({
          error: "Failed to update name. Please try again.",
          showErrorModal: true,
          loading: false,
        });
      }
    );
  }

  closeErrorModal() {
    this.setState({ showErrorModal: false, error: "" });
  }

  saveEmailChange() {
    if (!this.state.emailIsValid) {
      this.setState({
        error: "Please enter a valid email address",
        showErrorModal: true,
      });
      return;
    }

    const userId = get(this.props, "client.user_id");
    this.setState({ loading: true });

    updateClientById(
      userId,
      { email: this.state.email },
      (response) => {
        const client = get(response, "data.client", {});
        this.props.loadClient({ ...client, loggedIn: true });
        this.setState({
          loading: false,
          success: true,
        });
        setTimeout(() => this.setState({ success: false }), 3000);
      },
      (error) => {
        console.error("Error updating email:", error);
        this.setState({
          error: "Failed to update email address. Please try again.",
          showErrorModal: true,
          loading: false,
        });
      }
    );
  }

  closePasswordModal() {
    this.setState({
      openChangePassword: false,
      currentPasswordInput: "",
      newPassword: "",
      confirmNewPassword: "",
    });
  }

  changePassword() {
    const { currentPasswordInput, newPassword, confirmNewPassword } =
      this.state;

    if (!currentPasswordInput || !newPassword || !confirmNewPassword) {
      this.setState({
        error: "All password fields are required",
        showErrorModal: true,
      });
      return;
    }

    if (newPassword !== confirmNewPassword) {
      this.setState({
        error: "New password and confirmation do not match",
        showErrorModal: true,
      });
      return;
    }

    // Validate password using comprehensive rules
    const passwordErrors = generalCheckPassRules(newPassword);
    if (passwordErrors.length > 0) {
      this.setState({
        error: `Your new password must contain the following:\n• ${passwordErrors.join('\n• ')}`,
        showErrorModal: true,
      });
      return;
    }

    const userEmail = get(this.props, "client.email");
    this.setState({ loading: true });

    resetPasswordSubmission(
      {
        email: userEmail,
        current_password: currentPasswordInput,
        password: newPassword,
      },
      (response) => {
        this.setState({
          loading: false,
          success: true,
          openChangePassword: false,
          currentPasswordInput: "",
          newPassword: "",
          confirmNewPassword: "",
        });
        setTimeout(() => this.setState({ success: false }), 3000);
      },
      (error) => {
        console.error("Error changing password:", error);
        this.setState({
          error:
            "Failed to change password. Please check your current password and try again.",
          showErrorModal: true,
          loading: false,
        });
      }
    );
  }

  handleAvatarChange(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      this.setState({
        error: "Please select a valid image file.",
        showErrorModal: true,
      });
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      this.setState({
        error: "Please select an image smaller than 5MB.",
        showErrorModal: true,
      });
      return;
    }

    const userId = get(this.props, "client.user_id");
    this.setState({ loading: true });

    // Step 1: Get S3 presign info
    presignAvatar(
      userId,
      (presignResponse) => {
        const s3Data = get(presignResponse, "data", {});
        const { url, key } = s3Data;
        const formData = get(s3Data, "form-data", {});
        if (!url || !key || !formData) {
          this.setState({
            error: "Failed to prepare upload. Please try again.",
            showErrorModal: true,
            loading: false,
          });
          return;
        }

        // Step 2: Upload to S3
        const uploadFormData = new FormData();
        
        // Add S3 form data
        Object.keys(formData).forEach(key => {
          uploadFormData.append(key, formData[key]);
        });
        
        // Add the file
        uploadFormData.append("file", file);

        // Upload to S3 using uploadAvatar from Helpers
        uploadAvatar(
          url,
          uploadFormData,
          (uploadResponse) => {
            // Step 3: Save avatar URL to backend
            const avatarUrl = `${url}/${key}`;
            
            saveAvatar(
              avatarUrl,
              (saveResponse) => {
                // Fetch fresh client data to get updated avatar
                getClient(
                  (clientResponse) => {
                    const client = get(clientResponse, "data.result", {});
                    
                    this.props.loadClient({ ...client, loggedIn: true });
                    
                    // Clear the file input for better UX
                    const fileInput = document.getElementById("avatar-upload");
                    if (fileInput) fileInput.value = "";
                    
                    this.setState({
                      loading: false,
                      success: true,
                    });
                    
                    // Reload the page to show the updated avatar
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  },
                  (clientError) => {
                    console.error("Error fetching updated client data:", clientError);
                    // Still show success since avatar save worked
                    this.setState({
                      loading: false,
                      success: true,
                    });
                    
                    // Reload the page to show the updated avatar
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                );
              },
              (saveError) => {
                console.error("Error saving avatar:", saveError);
                this.setState({
                  error: "Failed to save avatar. Please try again.",
                  showErrorModal: true,
                  loading: false,
                });
              }
            );
          },
          (uploadError) => {
            console.error("Error uploading to S3:", uploadError);
            
            // Check if this is a CORS error but upload might have succeeded
            const errorMessage = uploadError?.message || '';
            const isCorSError = errorMessage.includes('Access-Control-Allow-Origin') || 
                               errorMessage.includes('CORS') ||
                               uploadError?.code === 'ERR_NETWORK';
            
            if (isCorSError) {
              // CORS error in development - upload might have succeeded
              // Try to save avatar anyway since S3 upload likely succeeded
              const avatarUrl = `${url}/${key}`;
              
              saveAvatar(
                avatarUrl,
                (saveResponse) => {
                  // Success - the upload worked despite CORS error
                  // Fetch fresh client data to get updated avatar
                  getClient(
                    (clientResponse) => {
                      const client = get(clientResponse, "data.result", {});
                      
                      this.props.loadClient({ ...client, loggedIn: true });
                      
                      // Clear the file input for better UX
                      const fileInput = document.getElementById("avatar-upload");
                      if (fileInput) fileInput.value = "";
                      
                      this.setState({
                        loading: false,
                        success: true,
                      });
                      
                      // Reload the page to show the updated avatar
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                      setTimeout(() => this.setState({ success: false }), 3000);
                    },
                    (clientError) => {
                      console.error("Error fetching updated client data:", clientError);
                      // Still show success since avatar save worked (CORS recovery backup)
                      this.setState({
                        loading: false,
                        success: true,
                      });
                      
                      // Reload the page to show the updated avatar
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                      setTimeout(() => this.setState({ success: false }), 3000);
                    }
                  );
                },
                (saveError) => {
                  // Avatar save failed - upload probably failed too
                  this.setState({
                    error: "Upload failed due to network restrictions. Please try again.",
                    showErrorModal: true,
                    loading: false,
                  });
                }
              );
            } else {
              // Other error
              this.setState({
                error: "Failed to upload image. Please try again.",
                showErrorModal: true,
                loading: false,
              });
            }
          }
        );
      },
      (presignError) => {
        console.error("Error getting presign data:", presignError);
        this.setState({
          error: "Failed to prepare upload. Please try again.",
          showErrorModal: true,
          loading: false,
        });
      }
    );
  }

  mainView() {
    const {
      firstName,
      lastName,
      email,
      phone,
      currentPassword,
      editingPhone,
      success,
    } = this.state;

    return (
      <>
        <div
          className="contentPrimary mb-32 txt-left"
          style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 500,
            fontSize: '40px',
            lineHeight: '1.3em',
          }}
        >
          Settings
        </div>

        {success && (
          <div
            className="mb-24 p-12 centered"
            style={{
              backgroundColor: "#d4edda",
              color: "#155724",
              border: "1px solid #c3e6cb",
              borderRadius: "4px",
              fontSize: "14px",
            }}
          >
            ✓ Information updated successfully!
          </div>
        )}

        <div className="centered mb-32">
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              className="w-h-60 br-rd-50"
              src={get(this.props, "client.avatar_url", "") || avatar}
              alt="avatar"
              style={{
                border: "1px solid #E2E2E2",
                width: "64px",
                height: "64px",
                cursor: "pointer",
              }}
              onClick={() => document.getElementById("avatar-upload").click()}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-8px",
                right: "-8px",
                backgroundColor: "white",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: "1px solid #E2E2E2",
                fontSize: "12px",
                color: "#323232",
                transition: "background-color 0.2s ease",
              }}
              onClick={() => document.getElementById("avatar-upload").click()}
            >
              <Edit style={{ fontSize: "12px" }} />
            </div>
            <input
              id="avatar-upload"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={this.handleAvatarChange}
            />
          </div>
        </div>

        <div
          className="form-container"
          style={{ maxWidth: "524px", margin: "0 auto" }}
        >
          {/* Name Fields */}
          <div className="row">
            <div className="col-xs-12 col-sm-6 form-group mb-24">
              <label className="contentPrimary size-16-20 mb-8">
                First Name
              </label>
              <div className={`${this.state.firstName ? "success" : ""}`}>
                <input
                  type="text"
                  value={this.state.firstName}
                  className="form-control generic-input-style size-16-24 contentPrimary"
                  onChange={(event) =>
                    this.setState({ firstName: event.target.value })
                  }
                  onBlur={() =>
                    this.saveFieldChange("First Name", this.state.firstName)
                  }
                  placeholder="First Name"
                />
                <img
                  className="input-checkmark input-checkmark-editted"
                  src={checkMark}
                  alt="chckmrk"
                />
              </div>
            </div>

            <div className="col-xs-12 col-sm-6 form-group mb-24">
              <label className="contentPrimary size-16-20 mb-8">
                Last Name
              </label>
              <div className={`${this.state.lastName ? "success" : ""}`}>
                <input
                  type="text"
                  value={this.state.lastName}
                  className="form-control generic-input-style size-16-24 contentPrimary"
                  onChange={(event) =>
                    this.setState({ lastName: event.target.value })
                  }
                  onBlur={() =>
                    this.saveFieldChange("Last Name", this.state.lastName)
                  }
                  placeholder="Last Name"
                />
                <img
                  className="input-checkmark input-checkmark-editted"
                  src={checkMark}
                  alt="chckmrk"
                />
              </div>
            </div>
          </div>

          {/* Email Field */}
          <div className="form-group mb-24">
            <label className="contentPrimary size-16-20 mb-8">Email</label>
            <div className={`${this.state.emailIsValid ? "success" : ""}`}>
              <EmailInput
                email={this.state.email}
                onEmailChange={({ email, isValid }) => {
                  this.setState({
                    email: email,
                    isValidEmail: isValid,
                    emailIsValid: isValid,
                  });
                }}
                className={`form-control generic-input-style size-16-24 contentPrimary ${
                  !this.state.emailIsValid && this.state.email ? "invalid" : ""
                }`}
                placeholder="Enter email address"
                onBlur={() => this.saveEmailChange()}
              />
              <img className="input-checkmark" src={checkMark} alt="chckmrk" style={{
                top: "16px",
                right: "16px"
              }} />
            </div>
            {!this.state.emailIsValid && this.state.email ? (
              <div className="small-red-message mt-8">
                Please enter a valid email address.
              </div>
            ) : null}
          </div>

          {/* Current Password Field */}
          <div className="form-group mb-24">
            <div style={{ display: "flex", alignItems: "end", gap: "16px" }}>
              <div style={{ flex: 1 }}>
                <label
                  className="contentPrimary size-16-20 font-weight-bold mb-8"
                  style={{ display: "block" }}
                >
                  Current Password
                </label>
                <div
                  className="form-control generic-input-style size-16-24 contentPrimary"
                  style={{
                    backgroundColor: "#F6F6F6",
                    padding: "14px 16px",
                    borderRadius: "4px",
                    border: "none",
                    color: "#AFAFAF",
                  }}
                >
                  {currentPassword}
                </div>
              </div>
              <button
                type="button"
                className="btn"
                style={{
                  backgroundColor: "#586B94",
                  color: "white",
                  padding: "10px 12px",
                  borderRadius: "9999px",
                  border: "none",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  height: "fit-content",
                  alignSelf: "flex-end",
                }}
                onClick={() => {
                  this.cancelEdit();
                  this.setState({
                    openChangePassword: true,
                  });
                }}
              >
                Change
              </button>
            </div>
          </div>

          {/* Phone Field */}
          <div className="form-group mb-24">
            <div style={{ display: "flex", alignItems: "end", gap: "16px" }}>
              <div style={{ flex: 1 }}>
                <label className="contentPrimary size-16-20 mb-8">Phone</label>
                {editingPhone ? (
                  <>
                    <div
                      className={`${this.state.isValidPhone ? "success" : ""}`}
                    >
                      <PhoneInput
                        showLable={false}
                        onPhoneNumberChange={({
                          isValidNumber,
                          number,
                          countryCode,
                        }) => {
                          this.setState({
                            tempPhone: number,
                            isValidPhone: isValidNumber,
                            countryCode: countryCode,
                          });
                        }}
                        className={`intl-tel-input generic-input-style size-16-24 contentPrimary ${
                          this.state.isValidPhone ? "valid" : "invalid"
                        } ${
                          !this.state.isValidPhone && this.state.tempPhone
                            ? "error-state"
                            : ""
                        }`}
                        phone={this.state.tempPhone}
                      />
                      <img
                        className="input-checkmark input-checkmark-editted"
                        src={checkMark}
                        alt="chckmrk"
                      />
                    </div>
                    {this.state.isValidPhone || !this.state.tempPhone ? null : (
                      <div className="small-red-message mt-8">
                        This number is invalid.
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    className="form-control generic-input-style size-16-24 contentPrimary"
                    style={{
                      backgroundColor: "#F6F6F6",
                      padding: "14px 16px",
                      borderRadius: "4px",
                      border: "none",
                      color: "#AFAFAF",
                    }}
                  >
                    {phone || "No phone number set"}
                  </div>
                )}
              </div>
              {editingPhone ? (
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    type="button"
                    className="btn grayStyled"
                    style={{
                      padding: "10px 12px",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: "pointer",
                      height: "fit-content",
                      border: "none",
                    }}
                    onClick={this.cancelEdit}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn ctaButton-enabled"
                    style={{
                      padding: "10px 12px",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: "pointer",
                      height: "fit-content",
                      border: "none",
                    }}
                    onClick={this.savePhoneChange}
                  >
                    Save
                  </button>
                </div>
              ) : (
                <button
                  type="button"
                  className="btn"
                  style={{
                    backgroundColor: "#586B94",
                    color: "white",
                    padding: "10px 12px",
                    borderRadius: "9999px",
                    border: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    height: "fit-content",
                    alignSelf: "flex-end",
                  }}
                  onClick={this.startEditingPhone}
                >
                  Change
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  render() {
    const loggedIn = get(this.props, "client.loggedIn", false);
    if (!loggedIn) {
      return (
        <SignupModal
          isSignin
          next={() => {
            window.location.reload();
          }}
        />
      );
    }
    return (
      <>
        <HelmetTag />
        <NavbarRedesignForMarketplace notBooking showMenu />
        <MainBackgroundWrapper
          noMarginTop={this.state.width < 800}
          bgImagePath={this.state.bgImagePath}
        >
          <div
            className={`${
              this.state.width >= 800 ? "border-radius-16" : ""
            } p-24`}
          >
            {this.mainView()}
          </div>
        </MainBackgroundWrapper>

        {/* Loading Overlay */}
        <LoadingOverlay showLoader={this.state.loading} />

        {/* Error Modal */}
        {this.state.showErrorModal && (
          <ErrorModal
            isOpen={this.state.showErrorModal}
            close={this.closeErrorModal}
          >
            <p>{this.state.error}</p>
          </ErrorModal>
        )}

        {/* Password Change Modal */}
        {this.state.openChangePassword && (
          <LatestModalDesign
            title="Change Password"
            isOpen={this.state.openChangePassword}
            close={this.closePasswordModal}
            hideFooter
          >
            <div className="p-24">
              <div className="form-group mb-16">
                <label
                  className="contentPrimary size-14-20 font-weight-bold mb-8"
                  style={{ display: "block" }}
                >
                  Current Password
                </label>
                <input
                  type="password"
                  className="form-control generic-input-style"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "4px",
                    border: "1px solid #E2E2E2",
                    fontSize: "16px",
                  }}
                  value={this.state.currentPasswordInput}
                  onChange={(e) =>
                    this.setState({ currentPasswordInput: e.target.value })
                  }
                  placeholder="Enter current password"
                />
              </div>

              <div className="form-group mb-16">
                <label
                  className="contentPrimary size-14-20 font-weight-bold mb-8"
                  style={{ display: "block" }}
                >
                  New Password
                </label>
                <input
                  type="password"
                  className="form-control generic-input-style"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "4px",
                    border: "1px solid #E2E2E2",
                    fontSize: "16px",
                  }}
                  value={this.state.newPassword}
                  onChange={(e) =>
                    this.setState({ newPassword: e.target.value })
                  }
                  placeholder={`Enter new password (${PASSWORD_RULES.minCharacterLength}+ chars, uppercase, lowercase, number, symbol)`}
                />
              </div>

              <div className="form-group mb-24">
                <label
                  className="contentPrimary size-14-20 font-weight-bold mb-8"
                  style={{ display: "block" }}
                >
                  Confirm New Password
                </label>
                <input
                  type="password"
                  className="form-control generic-input-style"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "4px",
                    border: "1px solid #E2E2E2",
                    fontSize: "16px",
                  }}
                  value={this.state.confirmNewPassword}
                  onChange={(e) =>
                    this.setState({ confirmNewPassword: e.target.value })
                  }
                  placeholder="Confirm new password"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  className="btn grayStyled"
                  style={{
                    padding: "12px 24px",
                    fontSize: "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                    border: "none",
                  }}
                  onClick={this.closePasswordModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn ctaButton-enabled"
                  style={{
                    padding: "12px 24px",
                    fontSize: "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                    border: "none",
                  }}
                  onClick={this.changePassword}
                >
                  Change Password
                </button>
              </div>
            </div>
          </LatestModalDesign>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  client: state.client,
});
export default connect(mapStateToProps, { loadClient })(Index);
